// Vue JS
import { createApp, defineAsyncComponent } from 'vue';
// ✅ Garde uniquement les composants critiques (utilisés partout)
import MenuActivator from "./js/components/MenuActivator.vue";
import HeaderScroll from "./js/components/HeaderScroll.vue";
import NewsFeed from "./js/components/NewsFeed.vue";
import ToggleSwitch from "./js/components/ToggleSwitch.vue";
import HomepageLive from "./js/components/HomepageLive.vue";

// ✅ Lazy load le reste (chargés seulement quand nécessaires)
const ContentHeading = defineAsyncComponent(() => import('./js/components/ContentHeading.vue'));
const EditionDropdown = defineAsyncComponent(() => import('./js/components/EditionDropdown.vue'));
const GalleryImage = defineAsyncComponent(() => import('./js/components/GalleryImage.vue'));
const FreePdfViewer = defineAsyncComponent(() => import('./js/components/FreePdfViewer.vue'));
const LockedPdfViewer = defineAsyncComponent(() => import('./js/components/LockedPdfViewer.vue'));
const ZoomImage = defineAsyncComponent(() => import('./js/components/ZoomImage.vue'));
const CollapsibleCard = defineAsyncComponent(() => import('./js/components/CollapsibleCard.vue'));
const SearchModal = defineAsyncComponent(() => import('./js/components/SearchModal.vue'));
const AutocompleteMulti = defineAsyncComponent(() => import('./js/components/AutocompleteMulti.vue'));
const ArticleListingSearch = defineAsyncComponent(() => import('./js/components/ArticleListingSearch.vue'));
const CqUpdate = defineAsyncComponent(() => import('./js/components/CqUpdate.vue'));
const DragDropSortable = defineAsyncComponent(() => import('./js/components/DragDropSortable.vue'));
const ContribBadge = defineAsyncComponent(() => import('./js/components/ContribBadge.vue'));
const SearchMagPdf = defineAsyncComponent(() => import('./js/components/SearchMagPdf.vue'));
const ArticleFavoriteButton = defineAsyncComponent(() => import('./js/components/ArticleFavoriteButton.vue'));
const MiniAudioPlayer = defineAsyncComponent(() => import('./js/components/MiniAudioPlayer.vue'));
const XlsReader = defineAsyncComponent(() => import('./js/components/XlsReader.vue'));
const FullCalendar = defineAsyncComponent(() => import('./js/components/FullCalendar.vue'));
const ImageAdaptive = defineAsyncComponent(() => import('./js/components/ImageAdaptive.vue'));
const CopyUrl = defineAsyncComponent(() => import('./js/components/CopyUrl.vue'));
const MenuMobile = defineAsyncComponent(() => import('./js/components/MenuMobile.vue'));
const IbexaRelationListEditor = defineAsyncComponent(() => import('./js/components/IbexaRelationListEditor.vue'));



// import * as pdfjsLib from 'pdfjs-dist'
// pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js'

// Styles
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './lightningcss/tailwind.css';
import './lightningcss/app.css';
import "@fortawesome/fontawesome-free/css/all.css";

// Bootstrap
// import './bootstrap';

// Import Swiper initializer
import { setupSwiperWithObserver } from './js/swiper-initializer';

// Script
import './js/audioplayer'
import './js/Utils'
import { DropdownMenu } from './js/script/dropdown-menu';
import backToTop from "./js/backToTop";

const contentId = window.ibexaContentData?.contentId;
const connectUrl = window.ibexaContentData?.connectUrl;

// Initialiser l'application Vue
const app = createApp({
    components: {
        MenuActivator,
        ContentHeading,
        EditionDropdown,
        HeaderScroll,
        GalleryImage,
        FreePdfViewer,
        LockedPdfViewer,
        ZoomImage,
        CollapsibleCard,
        SearchModal,
        AutocompleteMulti,
        ToggleSwitch,
        ArticleListingSearch,
        CqUpdate,
        DragDropSortable,
        ContribBadge,
        SearchMagPdf,
        ArticleFavoriteButton,
        MiniAudioPlayer,
        XlsReader,
        FullCalendar,
        ImageAdaptive,
        NewsFeed,
        CopyUrl,
        MenuMobile,
        HomepageLive,
        IbexaRelationListEditor
    },
    data() {
        return {
            isOpenMenu: false // Dropdown menu
        }
    }
});

app.mount('#app');


document.addEventListener("DOMContentLoaded", () => {
    // Initialiser Swiper
    setupSwiperWithObserver();

    // Back to top
    backToTop();

    new DropdownMenu('dropdown-menu-toggle', 'dropdown-menu');

    const lazyImages = document.querySelectorAll('.lazy');

    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const image = entry.target;
                image.src = image.dataset.src;
                image.classList.remove('lazy');
                observer.unobserve(image);
            }
        });
    });

    lazyImages.forEach(image => {
        imageObserver.observe(image);
    });

    // Gestion lexicon en javascript suite au changement de comportement : on ne passe plus par embed inline car sinon ça fait sauter le texte dans l'audio et dans le chapeau
    document.querySelectorAll('a[title^="[lexicon]"]').forEach(link => {
        const definition = link.getAttribute('title').replace('[lexicon] ', '');
        link.classList.add('tooltip');
        link.setAttribute('data-tip', definition);
        link.removeAttribute('title');
        link.addEventListener('click', e => e.preventDefault());
    });


    // CQ app controle

    document.addEventListener('DOMContentLoaded', function() {
        const bottomBarUrls = [
            'https://sfxpp.satellifacts.com',
            'https://sfxpp.satellifacts.com/',
            'https://sfxpp.satellifacts.com/fil-actu',
            'https://sfxpp.satellifacts.com/edition',
            'https://sfxpp.satellifacts.com/talents',
            'https://sfxpp.satellifacts.com/magazine-satellifacts'
        ];

        const currentUrl = window.location.href.replace(/\/$/, ''); // Enlève le slash final
        const isBottomBarPage = bottomBarUrls.some(url => url.replace(/\/$/, '') === currentUrl);

        if (typeof median !== 'undefined' && median.navigationTitles) {
            median.navigationTitles.update({
                showBackButton: !isBottomBarPage
            });
        }
    });




    // Gestion de l'impression - charger toutes les images lazy
    // let printMediaQuery = window.matchMedia('print');
    // let imagesLoaded = false;
    //
    // printMediaQuery.addEventListener('change', (e) => {
    //     if (e.matches && !imagesLoaded) {
    //         console.log('Chargement des images pour impression...');
    //
    //         const remainingLazyImages = document.querySelectorAll('.lazy[data-src]');
    //
    //         // Charger toutes les images
    //         remainingLazyImages.forEach(image => {
    //             if (image.dataset.src) {
    //                 image.src = image.dataset.src;
    //                 image.classList.remove('lazy');
    //             }
    //         });
    //
    //         imagesLoaded = true;
    //         console.log(`${remainingLazyImages.length} images chargées!`);
    //     }
    // });

});


